// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"_3J8IpjVuozXZLZFw6gMVIk","QuizWrapper":"_2cJp00Ro6MJ3wkCUwvq0fB"};